
import { defineComponent, reactive } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import OkButton from '@/modules/OktellModule/components/OkButton/index.vue'
import OkInput from '@/modules/OktellModule/components/OkInput/index.vue'
import OkModal from '@/modules/OktellModule/components/OkModal/index.vue'

import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import useNotifications from '@/common/composable/useNotifications'
import { orders } from '@/core/realisations/orders.realisation'

export default defineComponent({
    components: {
        OkButton,
        OkInput,
        OkModal,
    },
    props: {
        invoiceNumber: {
            type: String,
            default: null,
        },
        isEdit: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['date-confirm'],
    setup(_, { emit }) {
        const route = useRoute()
        const router = useRouter()
        const notifications = useNotifications()

        const invoice_id = Number(route.params.invoice_id as string)

        const state_date = reactive({
            is_open: false,
            is_loading: false,
            date: null as string | null,
        })

        const state_date_form$ = useVuelidate(
            {
                date: { required },
            },
            state_date
        )

        const onGoBack = () => {
            router.go(-1)
        }

        const onDateChanged = (value: string) => {
            state_date.date = value
        }

        const openDate = () => {
            state_date.is_open = true
        }

        const closeDate = () => {
            state_date.is_open = false
            state_date.date = null
        }

        const confirmDate = async () => {
            state_date_form$.value.$touch()
            if (!state_date.date) return

            try {
                state_date.is_loading = true

                const dateWithoutSecondsArray = state_date.date.split('T')
                const date = dateWithoutSecondsArray.join(' ') + ':00'

                const payload = {
                    date,
                    code: 211,
                }
                await orders.setNewPredictDate(invoice_id, payload)

                notifications.notify({ title: 'Дата успешно перенесена!', type: 'success' })
                closeDate()
                emit('date-confirm')
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При переносе даты произошла ошибка',
                })
            } finally {
                state_date.is_loading = false
            }
        }

        return {
            onGoBack,
            state_date_form$,
            invoice_id,
            state_date,
            openDate,
            onDateChanged,
            confirmDate,
            closeDate,
        }
    },
})
